import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Constants } from './../../../../components/common/constants';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  imgSrc = '';
  textTitle = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type: any},
    private dialogRef: MatDialogRef<FormComponent>,
    private router: Router
  ) { }

  ngOnInit(): void {
    switch (this.data.type) {
      case Constants.typePersonalMonth:
        this.imgSrc = 'assets/images/formularios/personal_mensual.png';
        this.textTitle = 'Ayúdanos a completar el formulario para continuar con <br> la compra de tu <b>suscripción mensual</b> a <b>FAD®personal.</b>';
        break;
      case Constants.typePersonalAnual:
        this.imgSrc = 'assets/images/formularios/personal_prepago.png';
        this.textTitle = 'Ayúdanos a completar el formulario para continuar con <br> la compra de tu <b>plan prepago</b> a <b>FAD®personal.</b>';
        break;
      case Constants.typeCompanyMonth:
        this.imgSrc = 'assets/images/formularios/empresa_mensual.png';
        this.textTitle = 'Ayúdanos a completar el formulario para continuar con <br> la compra de tu <b>suscripción mensual</b> a <b>FAD®empresa.</b>';
        break;
      case Constants.typeCompanyAnual:
        this.imgSrc = 'assets/images/formularios/empresa_prepago.png';
        this.textTitle = 'Ayúdanos a completar el formulario para <b>cotizar tu plan <br> prepago anual a FAD® empresa.</b>';
        break;
      case Constants.typeCompanyIntegration:
        this.imgSrc = 'assets/images/formularios/integracion_especial.png';
        this.textTitle = 'Ayúdanos a completar el formulario para <b>platicar de tu</b> <br> <b>Integración especial FAD®</b>';
        break;
    }
  }

  isPersonal(): boolean {
    return this.data.type === Constants.typePersonalMonth || this.data.type === Constants.typePersonalAnual;
  }

  isCompanyMonth(): boolean {
    return this.data.type === Constants.typeCompanyMonth;
  }

  isCompanyAnual(): boolean {
    return this.data.type === Constants.typeCompanyAnual;
  }

  isCompanyIntegration(): boolean {
    return this.data.type === Constants.typeCompanyIntegration;
  }

  close(action): void {
    this.dialogRef.close(action);
  }

  privacy(): void {
    this.router.navigate(['/aviso-de-privacidad']);
    this.close(true);
  }

}
